import { useQueryState } from 'nuqs';

/**
 * Кастомный хук, обёртка над `useQueryState` из библиотеки `nuqs`
 * для управления значением одного query-параметра в адресной строке.
 *
 * Упрощает чтение и обновление параметра через `state` и `setState`,
 * а также обеспечивает реактивность — при изменении query‑параметра компонент перерисуется.
 *
 * @param queryKey Ключ параметра в строке запроса (например: `'modal_mode'`, `'tab'`).
 *
 * @returns Объект с:
 * - `state`: текущее значение параметра (или `null`, если он отсутствует);
 * - `setState`: функция для установки или удаления параметра (если передать `null`, параметр будет удалён).
 *
 * @example
 * const { state, setState } = useNuqsQueryState('modal_mode');
 *
 * useEffect(() => {
 *   if (state === 'create') {
 *     // открыть модальное окно
 *   }
 * }, [state]);
 *
 * setState('create'); // установить параметр
 * setState(null);     // удалить параметр
 */

export const useNuqsQueryState = (queryKey: string) => {
    const [state, setState] = useQueryState(queryKey);

    const clearQueryValue = () => {
        void setState(null);
    };

    return {
        state,
        setState,
        clearQueryValue,
    };
};
